import { ForgotPass } from './style'

interface IForgotPassProps {
  children: JSX.Element[] | JSX.Element | string
  to?: string
}

export default function RecoverPass(props: IForgotPassProps) {
  const { children, to } = props
  return (
    <ForgotPass {...props} to={to || ''}>
      {children}
    </ForgotPass>
  )
}
